import { Location } from "@angular/common";
import { User } from "./../../../core/models/auth.models";
import { ServicesService } from "./../../../pages/services/services.service";
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedService } from "app/shared/services/shared.service";
import { DepartmentsService } from "app/view/departments/services/departments.service";
import { DomainControlComponent } from "app/view/mangement/domains/domain-control/domain-control.component";
import { AuthenticationService } from "app/core/services/auth.service";
import { ControlEmployeeTasksComponent } from "app/view/projects/module/tasks/components/control-employee-tasks/control-employee-tasks.component";

@Component({
  selector: "app-banner",
  templateUrl: "./banner.component.html",
  styleUrls: ["./banner.component.scss"],
})

// Component create with Eng Ahmed Abdelhameed Ali
export class BannerComponent implements OnInit, AfterViewInit {
  @Input() companyID: number = 0;
  @Input() title: string = "";
  @Input() btnAddText: string = "";
  @Input() itemsList: any[] = [];
  @Input() department: string = "";
  // not used for now
  @Input() showFilter: boolean = false;
  @Input() ShowAdd: boolean = false;
  @Input() ShowCalendar: boolean = false;
  @Input() ShowSearch: boolean = false;

  @Output() openFunAdd: EventEmitter<any> = new EventEmitter();
  @Output() openFilter: EventEmitter<any> = new EventEmitter();
  @Output() openCalender: EventEmitter<boolean> = new EventEmitter(false);

  @Output() getListItemEvent: EventEmitter<number> = new EventEmitter();

  openCalenderValue: boolean = false;
  openSearch: boolean = false;
  lang: string = "";
  /////////////////////////////////////////////////
  userCompanies: any[] = [];
  allDepartments: any[] = [];
  @Output() companyId: EventEmitter<number> = new EventEmitter();
  @Output() departmentID: EventEmitter<number> = new EventEmitter();
  isInTasksWithoutProject: boolean = false;
  hasPermissionForTasks: boolean = false;

  ///////////////////////////////////////////////
  constructor(
    private _formBuilder: FormBuilder,
    private _ActivatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private router: Router,
    private _DepartmentsService: DepartmentsService,
    private _ServicesService: ServicesService,
    private _Location: Location,
    public _Auth: AuthenticationService,
  ) {}

  ngOnInit(): void {
    this.lang = JSON.parse(localStorage.getItem("lang_ERP"))?.lang || "ar";
    (this._Location.path());
    if (this._Location.path().includes("tasks-without-project")) {
      this.isInTasksWithoutProject = true;
    }
    this._ServicesService.getUserCompanies().subscribe({
      next: (res: any) => {
          this.userCompanies = res.data;
          (this.userCompanies[0].id);
          let id = this.userCompanies[0].id;
          this.companyID = id;
          this.companyId.emit(id);
          (this.userCompanies);
          this._DepartmentsService
            .ListOfDepartment(this.userCompanies[0].id)
            .subscribe({
              next: (res: any) => {
                this.allDepartments = res.data;
                if (this.allDepartments.length > 1) {
                  this.departmentID.emit(this.allDepartments[0].id);
                  // Stop For Now
                  // Show All Departments
                  // this.departmentID.emit(0);

                }
                else{
                  this.departmentID.emit(this.allDepartments[0].id);
                }
              },
              error: (err: any) => {
                (err);
                let dateFromLocal:any = localStorage.getItem("user_ERP");
                if (dateFromLocal) {
                  dateFromLocal = JSON.parse(dateFromLocal);
                  this.departmentID.emit(dateFromLocal.department_Id[0]);
                }
                else{
                  this.allDepartments = [];
                // No Departments Permission
                this.departmentID.emit(null);
                }
              },
              complete: () => {},
            });
    
    },error: (err: any) => {
      (err);
      this.userCompanies = [];
      this.companyID = null;
      this.companyId.emit(null);

    },complete: () => {

    }
    });
    this._DepartmentsService.ListOfDepartment().subscribe({
      next: (res: any) => {
        this.allDepartments = res.data;

    },error: (err: any) => {
     
    },complete: () => {

    }
    })

  }
  ngAfterViewInit(): void {
    // setTimeout(() => {
    //   this.getListItemEvent.emit(this.itemsList[0]?.id)
    // }, 1000);
  }
  ngOnChanges(changes: SimpleChanges): void {
    (changes);
  }

  openADD() {
    this.openFunAdd.emit(true);
  }

  operFilter() {
    this.openFilter.emit("");
  }

  openClendarr() {
    this.openCalenderValue = !this.openCalenderValue;
    this.openCalender.emit(this.openCalenderValue);
  }

  change(Event: any) {
    // this.router.navigate([`${Event.target.value}`])
    // const currentUrl = this.router.url; // e.g., /companies/3/tasks-without-project/21
    // const updatedUrl = currentUrl.replace(/\/\d+$/, `/${Event.target.value}`);
    // this.router.navigateByUrl(updatedUrl).then(()=> location.reload());
    this.getListItemEvent.emit(Event.target.value);
  }
  changeSelectedCompany(event: any) {
    this.companyId.emit(event.target.value);
    this.companyID = event.target.value;
    (event.target.value);
    this._DepartmentsService
      .ListOfDepartment(event.target.value)
      .subscribe({
        next: (res: any) => {
          this.allDepartments = res.data;
          (this.allDepartments);
          if (this.allDepartments.length > 1) {
            this.departmentID.emit(this.allDepartments[0].id);
            // // Stop For Now
            // // Show All Departments
            // this.departmentID.emit(null);
          }else{
            this.departmentID.emit(this.allDepartments[0].id);
          }
        },
        error: (err) => {
          (err);
          if(err.status == 403 && err.statusText == "Forbidden"){
          this.allDepartments = [];
          // No Departments Permission
          this.departmentID.emit(null);
          }
        },
        complete: () => {},
      }

    );
  }
  changeSelectedDepartment(event: any) {
    this.departmentID.emit(event.target.value);
    //// Stop For Now
    // if (event.target.value == "0") {
    //   this.departmentID.emit(0);
    // }
    // else{
    //   this.departmentID.emit(event.target.value);
    // }
 
  }
  open() {
    // (this.companyID);
    // this.modalService.open(ControlEmployeeTasksComponent, {
    //   size: "xl",
    //   centered: true,
    // });
    // this.ngbModal.open(ControlEmployeeTasksComponent,{size:'xl', centered: true})

    // const modalRef = this.ngbModal.open(ControlEmployeeTasksComponent,{size:'xl', centered: true})
    // modalRef.componentInstance.companyID = this.companyID;
    // (this.companyID)
  }
}
